/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAwsSaasUserManagedIndividual extends models.StorageConfigurationBaseForAwsSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAwsSaasUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAwsSaasUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAwsSaasUserManagedIndividual>): StorageConfigurationForAwsSaasUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForAwsSaasUserManagedIndividual(), model);
        StorageConfigurationForAwsSaasUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAwsSaasUserManagedIndividual>): StorageConfigurationForAwsSaasUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForAwsSaasUserManagedIndividual.newInstance(<StorageConfigurationForAwsSaasUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAwsSaasUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForAwsSaasUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAwsSaasUserManagedIndividual): boolean {
        if (models.StorageConfigurationBaseForAwsSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAwsSaasUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
